/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Link } from "react-router-dom";
import L from "../Lang"
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";
import React from "react";

class LabManagerMenuItem extends React.Component {
    render() {
        return <li className="list-group-item"><Link role="button" to={this.props.to} className="text-dark d-block"><Icon icon={this.props.icon} /> {this.props.title}</Link></li>;
    }
}

class LabManager extends BaseCom {
    render() {
        return <div className="container-fluid">
            <h1><L>Lab Manager</L></h1>
            <ul className="list-group">
                <LabManagerMenuItem to="/lab/location" icon="faBuilding" title="Lab Locations" />
                <LabManagerMenuItem to="/panel/manage/list" icon="faVirus" title="Panels" />
                <LabManagerMenuItem to="/target/manage/list" icon="faBullseye" title="Panel Targets" />
                <LabManagerMenuItem to="/productline/list" icon="faPuzzlePiece" title="Product Lines" />
                <LabManagerMenuItem to="/specimentype/list" icon="faFlaskVial" title="Specimen Types" />
                <LabManagerMenuItem to="/report-template/list" icon="faPenNib" title="Report Templates" />
                <LabManagerMenuItem to="/rule/list" icon="faTachographDigital" title="Rules" />
            </ul>
        </div>;
    }
}

export default withParamsAndNavigate(LabManager);